import { render, staticRenderFns } from "./TransportDialog.vue?vue&type=template&id=cbf3771e&"
import script from "./TransportDialog.vue?vue&type=script&lang=js&"
export * from "./TransportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports